var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_50_5408)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5933 2.66797H5.22C4.88992 2.67671 4.57662 2.81535 4.34818 3.05378C4.11974 3.2922 3.99461 3.61115 4 3.9413V20.0613C3.99461 20.3915 4.11974 20.7104 4.34818 20.9488C4.57662 21.1873 4.88992 21.3259 5.22 21.3346H18.78C19.1101 21.3259 19.4234 21.1873 19.6518 20.9488C19.8803 20.7104 20.0054 20.3915 20 20.0613V7.94797L14.5933 2.66797ZM14 8.66797V3.89464L18.8667 8.66797H14Z",
    fill: "#CCCCCC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_50_5408"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIcon);
export default __webpack_public_path__ + "static/media/fileIcon.a2b846d0ec03d6c859da37682c7d2b1a.svg";
export { ForwardRef as ReactComponent };